import {INotification} from '../../app/shared/interfaces/notification.interface';
import {NotificationTypeEnum} from '../../app/shared/interfaces/NotificationTypeEnum';

export const userNotificationsMock = {
  items: [
    {
      id: 0,
      type: NotificationTypeEnum.FileSync,
      createDate: '2020-10-05T14:48:00.000Z',
    },
    {
      id: 1,
      type: NotificationTypeEnum.ConnectionError,
      createDate: '2021-07-05T14:48:00.000Z',
    },
    {
      id: 2,
      type: NotificationTypeEnum.OrderReceived,
      createDate: '2021-07-05T14:48:00.000Z',
    },
    {
      id: 3,
      type: NotificationTypeEnum.NewTeammate,
      createDate: '2021-08-05T14:48:00.000Z',
      userName: 'Whitney Francis',
    },
    {
      id: 4,
      type: NotificationTypeEnum.OrderReceived,
      createDate: '2021-08-05T14:48:00.000Z',
    },
  ] as INotification[],
  count: 12,
  offset: 10,
  step: 0,
};
